import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoggedInAuthGuard } from '@app/_guards/auth.guard';
import { VendorFormGuard } from '@app/_guards/vendor-form.guard';
import { RootComponent } from './_components/root/root.component';
import { LangGuard } from './_guards/lang.guard';
import {
    BlogsGuard,
    ProfessionalsGuard,
    QuotationsFeatureGuard,
    ServicesGuard
} from './_guards/site.guard';
import { DirectionService } from './_services/direction.service';
import { ApplyForVendorComponent } from './pages/footer/components/apply-for-vendor/apply-for-vendor.component';
import { VendorFormComponent } from './pages/footer/components/apply-for-vendor/vendor-form.component';
import { PageHomeOneComponent } from './pages/page-home-one/page-home-one.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

import { VendorFormSuccessComponent } from './pages/footer/components/apply-for-vendor/vendor-form-success/vendor-form-success.component';
import { VendorSubscriptionSuccessComponent } from './pages/vendor-subscription-success/vendor-subscription-success.component';
import { AiTokensSuccessComponent } from './pages/ai-tokens-success/ai-tokens-success.component';
import { CompleteVendorRegisterComponent } from './pages/footer/components/complete-vendor-register/complete-vendor-register.component';
import { MainCategoryResolverService } from './_resolvers/category-products-resolver.service';
import { RedirectionGuard } from './_guards/redirection.guard';

import { LayoutComponent } from './pages/quotation-requests/components/layout/layout.component';

import { combineAll } from 'rxjs/operators';
import { PageTestComponent } from './pages/page-test/page-test.component';

var Routechildren: any[] = [
    {
        path: '',
        pathMatch: 'full',
        component: PageHomeOneComponent,
        //redirectTo: 'en',
        canActivate: [LangGuard]
    },
    {
        path: 'test',
        component: PageTestComponent
    },
    {
        path: 'faq',
        loadChildren: () =>
            import('./pages/page-faq/faq.module').then(m => m.FaqModule)
    },
    {
        path: 'boq',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./pages/boq/boq.module').then(m => m.BoqModule)
            }
        ]
    },
    {
        path: 'boq-projects',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./pages/boq-projects/boq-projects.module').then(
                        m => m.BoqProjectsModule
                    )
            }
        ]
    },
    {
        path: 'boq-project-details/:id',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import(
                        './pages/boq-project-details/boq-project-details.module'
                    ).then(m => m.BoqProjectDetailsModule)
            }
        ]
    },
    {
        path: 'boq/create/:projectId',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadChildren: () =>
                    import('./pages/boq/boq.module').then(m => m.BoqModule)
            }
        ]
    },

    {
        path: 'support',
        loadChildren: () =>
            import('./pages/page-contact-us/contact-us.module').then(
                m => m.ContactUsModule
            )
    },
    {
        path: 'account',
        loadChildren: () =>
            import('./pages/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthGuard]
    },
    {
        path: 'rfq',
        loadChildren: () =>
            import('./pages/quotation-requests/quotation-requests.module').then(
                m => m.QuotationRequestsModule
            )
    },
    {
        path: 'blog',
        canActivate: [BlogsGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/blog/blog.module').then(m => m.BlogModule)
    },
    {
        path: 'ask-qetaat',
        loadChildren: () =>
            import('./pages/page-ask/page-ask-routing.module').then(
                m => m.PageAskRoutingModule
            )
    },

    {
        path: 'category',
        loadChildren: () =>
            import('./pages/page-category/category.module').then(
                m => m.CategoryModule
            )
    },
    /* {
        path: 'register',
        canActivate: [LoggedInAuthGuard],
        runGuardsAndResolvers: "always",
        loadChildren: () => import('./pages/account/pages/register/register.module').then(m => m.RegisterModule)
    }, */
    {
        path: 'register',
        canActivate: [LoggedInAuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/account/pages/page-login/login.module').then(
                m => m.LoginModule
            )
    },
    {
        path: 'login',
        canActivate: [LoggedInAuthGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/account/pages/page-login/login.module').then(
                m => m.LoginModule
            )
    },
    {
        path: 'product',
        loadChildren: () =>
            import('./pages/page-product/product.module').then(
                m => m.ProductModule
            )
    },
    {
        path: 'service',
        canActivate: [ServicesGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/page-service/service.module').then(
                m => m.ServiceModule
            )
    },
    {
        path: 'professional',
        canActivate: [ProfessionalsGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import(
                './pages/page-professional/professional-service.module'
            ).then(m => m.ProfessionalServiceModule)
    },

    {
        path: 'property',
        loadChildren: () =>
            import('./pages/page-property/property.module').then(
                m => m.PropertyModule
            )
    },

    {
        path: 'search',
        loadChildren: () =>
            import('./pages/page-search/search-routing.module').then(
                m => m.SearchRoutingModule
            )
    },
    {
        path: 'vendor',
        loadChildren: () =>
            import('./pages/page-company/vendor.module').then(
                m => m.VendorModule
            )
    },

    {
        path: 'site',
        loadChildren: () =>
            import('./pages/site/site.module').then(m => m.SiteModule)
    },
    {
        path: 'cart',
        loadChildren: () =>
            import('./pages/page-cart/cart.module').then(m => m.CartModule)
    },
    {
        path: 'request-quotation',
        loadChildren: () =>
            import(
                './pages/page-request-quotation/request-quotation.module'
            ).then(m => m.RequestQuotationModule)
    },
    {
        path: 'quotation-cart',
        canActivate: [AuthGuard, QuotationsFeatureGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/page-quotation-cart/quotation-cart.module').then(
                m => m.QuotationModule
            )
    },
    {
        path: 'quotation',
        canActivate: [AuthGuard, QuotationsFeatureGuard],
        runGuardsAndResolvers: 'always',
        loadChildren: () =>
            import('./pages/page-quotation/quotation.module').then(
                m => m.QuotationDetailsModule
            )
    },
    {
        path: 'checkout',
        loadChildren: () =>
            import('./pages/page-checkout/checkout.module').then(
                m => m.CheckoutModule
            )
    },
    {
        path: 'checkout-s',

        loadChildren: () =>
            import('./pages/page-new-checkout/checkout.module').then(
                m => m.CheckoutModule
            )
    },
    {
        path: 'terms',
        loadChildren: () =>
            import('./pages/page-vendor-terms/vendor-terms.module').then(
                m => m.VendorTermsModule
            )
    },

    {
        path: 'order',
        loadChildren: () =>
            import('./pages/orders/orders.module').then(m => m.OrdersModule)
    },
    {
        path: 'order-success',
        loadChildren: () =>
            import('./pages/order-success-page/order-success-page.module').then(
                m => m.OrderSuccessPageModule
            )
    },
    {
        path: 'new-success',

        loadChildren: () =>
            import('./pages/order-success-new/order-success-new.module').then(
                m => m.OrderSuccessNewModule
            )
    },

    {
        path: 'not-found',
        loadChildren: () =>
            import('./pages/not-found-page/not-found-page-routing.module').then(
                m => m.NotFoundPageRoutingModule
            )
    },
    {
        path: 'forgot-password',
        loadChildren: () =>
            import('./pages/forgot-password/forgot-password.module').then(
                m => m.ForgotPasswordModule
            )
    },
    {
        path: 'reset-password',
        loadChildren: () =>
            import('./pages/page-reset-password/reset-password.module').then(
                m => m.ResetPasswordModule
            )
    },
    {
        path: 'page',
        loadChildren: () =>
            import('./pages/static-pages/static-pages.module').then(
                m => m.StaticPagesModule
            )
    },
    {
        path: 'apply-for-vendor',
        component: ApplyForVendorComponent
    },
    {
        path: 'vendor-request-success',
        component: VendorFormSuccessComponent
    },
    {
        path: 'vendor-subscription-success',
        component: VendorSubscriptionSuccessComponent
    },
    {
        path: 'ai-tokens-success',
        component: AiTokensSuccessComponent
    },
    {
        path: 'vendor-form/:type',
        canActivate: [VendorFormGuard],
        component: VendorFormComponent
    },
    {
        path: 'complete-vendor-registration/:id',

        component: CompleteVendorRegisterComponent
    },

    {
        path: 'compare',
        loadChildren: () =>
            import('./pages/page-compare/compare.module').then(
                m => m.CompareModule
            )
    },
    {
        path: 'track-order',
        loadChildren: () =>
            import('./pages/page-track-order/track-order.module').then(
                m => m.TrackOrderModule
            )
    },
    {
        path: 'recruit',
        loadChildren: () => import('./pages/recruit/recruit-routing.module').then(m => m.RecruitRoutingModule)
    },
    {
        path: '**',
        component: PageNotFoundComponent
    }
];
const routes: Routes = [
    {
        path: 'maintenance',
        loadComponent: () =>
            import('./pages/maintenance/maintenance.component').then(
                m => m.MaintenanceComponent
            )
    },
    {
        path: 'en/maintenance',
        loadComponent: () =>
            import('./pages/maintenance/maintenance.component').then(
                m => m.MaintenanceComponent
            )
    },
    {
        path: 'ar/maintenance',
        loadComponent: () =>
            import('./pages/maintenance/maintenance.component').then(
                m => m.MaintenanceComponent
            )
    },
    {
        path: 'login',
        canActivate: [LoggedInAuthGuard],
        runGuardsAndResolvers: 'always',
        data: { loginOnly: true },
        loadChildren: () =>
            import('./pages/account/pages/page-login/login.module').then(
                m => m.LoginModule
            )
    },
    {
        path: 'en',
        resolve: { mainCategory: MainCategoryResolverService },
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'classic',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        canActivate: [RedirectionGuard, LangGuard],
        children: Routechildren
    },
    {
        path: 'ar',
        resolve: { mainCategory: MainCategoryResolverService },
        component: RootComponent,
        data: {
            // Header layout. Choose one of ['classic', 'compact'].
            headerLayout: 'classic',
            // Dropcart type. Choose one of ['dropdown', 'offcanvas'].
            dropcartType: 'dropdown'
        },
        canActivate: [RedirectionGuard, LangGuard],
        children: Routechildren
    },
    {
        path: '',
        pathMatch: 'full',
        component: PageHomeOneComponent,
        canActivate: [LangGuard]
    },
    {
        path: '**',
        component: PageHomeOneComponent,
        canActivate: [LangGuard]
    }
];
@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            initialNavigation: 'enabledBlocking'
        })
    ],
    exports: [RouterModule],
    providers: [DirectionService]
})
export class AppRoutingModule {}
